import { memo } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { ButtonBase } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { ALL, ALLOCATED, UNALLOCATED } from "../../consts/routeDetails";
import {
  ALLOCATED_ROUTES,
  ALL_ROUTES,
  UNALLOCATED_ROUTES,
} from "../../consts/sentryIds";
import { palette } from "../../theme/palette";

import { routeViewSelector } from "../../reducers/matrixProfile/selectors";
import { setRouteView } from "../../reducers/matrixProfile";

import { View } from "../View";
import { AllRoutes, AllocatedRoutes, UnallocatedRoutes } from "../Icons";

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "space-around",
    paddingTop: "5px",
    paddingBottom: "5px",
    color: "white",
    "& svg": {
      height: "32px",
      width: "32px",
      cursor: "pointer",
    },
  },
  padding: {
    height: "28px !important",
    width: "28px !important",
    paddingTop: "2px",
    paddingBottom: "2px",
  },
});

export const RouteViews = memo(() => {
  const view = useSelector(routeViewSelector);
  const dispatch = useDispatch();
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <ButtonBase
        onClick={() => {
          dispatch(setRouteView(ALLOCATED));
        }}
        sentryId={ALLOCATED_ROUTES}
        disableRipple={true}
      >
        <AllocatedRoutes
          fill={
            view === ALLOCATED ? palette.orange : palette.typography.white.high
          }
          sentryId={ALLOCATED_ROUTES}
        />
      </ButtonBase>
      <ButtonBase
        onClick={() => {
          dispatch(setRouteView(UNALLOCATED));
        }}
        disableRipple={true}
        sentryId={UNALLOCATED_ROUTES}
      >
        <UnallocatedRoutes
          fill={
            view === UNALLOCATED
              ? palette.orange
              : palette.typography.white.high
          }
          sentryId={UNALLOCATED_ROUTES}
        />
      </ButtonBase>
      <ButtonBase
        onClick={() => {
          dispatch(setRouteView(ALL));
        }}
        sentryId={ALL_ROUTES}
        disableRipple={true}
      >
        <AllRoutes
          className={styles.padding}
          fill={view === ALL ? palette.orange : palette.typography.white.high}
          sentryId={ALL_ROUTES}
        />
      </ButtonBase>
    </View>
  );
});

export default RouteViews;

RouteViews.propTypes = {
  selected: PropTypes.oneOf([ALL, ALLOCATED, UNALLOCATED]),
};
